import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Worker } from '~weekly-planner/lib/common';

const UserState = (state: RootState) => state.weeklyPlanner.users;

export const selectAll = (state: RootState) => UserState(state).rows;
export const selectSimulated = (state: RootState) => UserState(state).simulated;

export const selectLoading = (state: RootState) => UserState(state).loading;
export const selectRowsLoading = (state: RootState) => UserState(state).loadingRows;
export const selectHasLoaded = (state: RootState) => UserState(state).hasLoaded;
export const selectFilterOptions = (state: RootState) => UserState(state).filterOptions;
export const selectErrorResponse = (state: RootState) => UserState(state).error;
export const selectParams = (state: RootState) => UserState(state).params;

export const selectRenderable = createSelector([selectAll, selectSimulated], (users: Worker[], simulated: Worker[]) => {
  const simulatedMap = new Map(simulated.map((worker) => [worker.id, worker]));

  return users.map((user) => {
    const simulatedChange = simulatedMap.get(user.id);
    return simulatedChange || user;
  });
});

export const selectRowLoading = createSelector(
  [selectRowsLoading, (_: RootState, id: number) => id],
  (rows, id) => rows[id] ?? 'idle',
);
